module.exports = {
    "Empty": `Vazio`
};


//# sourceMappingURL=pt-BR.main.js.map
